import { Cadence } from "@/types/agent-summary"

export const CADENCE_LABELS: Record<Cadence, string> = {
  daily: "Daily",
}

/** Strips everything but digits — keeps target-price inputs whole-number only (the backend rejects fractional targets). */
export function wholeNumberInputValue(value: string) {
  return value.replace(/\D/g, "")
}

/** Parses a positive whole number, NaN otherwise. Matches the backend's target_price validation. */
export function parsePositiveWholeNumber(value: string) {
  if (!/^\d+$/.test(value)) return NaN
  const parsed = Number(value)
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : NaN
}
